/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyBrandRefDto } from './companyBrandRefDto';
import { CompanyRefDto } from './companyRefDto';
import { ProjectRef } from './projectRef';


export interface UpdateForecastDto { 
    title?: string;
    project?: ProjectRef;
    agency?: CompanyRefDto;
    client?: CompanyRefDto;
    brand?: CompanyBrandRefDto;
    startDateTime?: string;
    endDateTime?: string;
    description?: string;
    teamForecast?: Array<string>;
    totalForecastHrs?: number;
}

